export default {
  en: 'Adjust the colour',
  ar: 'تعديل اللون'
};
